$('.u-disable-on-submit form').submit(function(event) {
    if ($(this).data('submitted')) {
        event.preventDefault();
    } else {
        $(this).data('submitted', true);
        $(this).find('input[type=submit], button[type=submit]').addClass('c-button--disabled');
    }
});



// WEBPACK FOOTER //
// ./src/js/components/disable-on-submit.js